"use client";

import { Bell, Loader2Icon, Repeat } from "lucide-react";
import { Button } from "../ui/button";
import { SetStateAction, useEffect, useRef, useState } from "react";
import { useClickOutside } from "@/hooks/useClickOutside";
import { cn } from "@/lib/utils";
import { NotificationType } from "@/react-queries/queries/notifications/types";
import { useApiGet, useApiSend } from "@/react-queries/custom-request";
import { useUser } from "@/zustand-hooks/user-hook";
import { getAllNotifications } from "@/react-queries/queries/notifications";
import { Link } from "@/i18n/routing";
// import { useSocket } from "@/providers/SocketProvider";
import { useLocale, useTranslations } from "next-intl";
import NotificationItem from "./NotificationsMobile/NotificationItem";

const Notifications = ({ setNotification }: { setNotification: React.Dispatch<SetStateAction<NotificationType | undefined>> }) => {
    const locale = useLocale();
    // const { socket } = useSocket();
    const user = useUser(s => s.user);
    const [isOpen, setIsOpen] = useState(false);
    const buttonRef = useRef(null);
    const translate = useTranslations('Header.notifications');
    const translate_empties = useTranslations('empties');
    useClickOutside(buttonRef, () => setIsOpen(false));
    // @ts-ignore
    const { data, isLoading, isError, refetch } = useApiGet<{ notifications: NotificationType[] }>(['notifications', user?.id], getAllNotifications);
/* 


    useEffect(() => {
        socket.on('notification', () => refetch());
        return () => { socket.off('notification') };
    }, []);
 */
    return (
        <div ref={buttonRef} className="relative z-[100]">
            <Button className="relative" size={"icon"} onClick={() => setIsOpen(!isOpen)}>
                <Bell />
                {
                    // @ts-ignore
                    data?.notifications &&
                        // @ts-ignore
                        data?.notifications.length > 0 &&
                        // @ts-ignore
                        data?.notifications.filter(n => !n.view).length > 0 ?
                        // @ts-ignore
                        <span className="absolute top-0 right-0 -mt-2 bg-red-700 text-xs font-bold rounded-full text-white px-2">{data?.notifications.filter(n => !n.view).length}</span>
                        : null
                }
            </Button>

            <div
                className={cn(
                    "absolute origin-top-right transition-transform overflow-hidden rounded-2xl mt-2 right-0 w-[300px] bg-white dark:bg-slate-700 shadow-md",
                    isOpen ? "scale-100" : "scale-0"
                )}
            >
                <div className="flex flex-col gap-4 p-4 text-white bg-[#405189] font-bold">
                    <p>{translate('title')}</p>
                </div>
                <div className="dark:even:[&>div]:bg-slate-600 even:[&>div]:bg-slate-50 max-h-[250px] overflow-y-auto">
                    {
                        // @ts-ignore
                        data?.notifications &&
                            // @ts-ignore
                            data?.notifications.length > 0 &&
                            // @ts-ignore
                            data?.notifications.filter(n => !n.view).length > 0 ?
                            // @ts-ignore
                            data?.notifications.filter(n => !n.view).map((item, i) => (
                                <div key={`${item.date}-${item.title}-${i}`} className="cursor-pointer hover:opacity-90">
                                    <NotificationItem item={item} locale={locale} setNotification={setNotification} />
                                </div>
                            ))
                            : isError ?
                                <div className="bg-red-400 bg-opacity-25 text-white flex items-center p-4 text-xs gap-2">
                                    An error occured while getting notifications
                                    <button
                                        disabled={isLoading}
                                        className="bg-red-700 text-white rounded-sm shrink-0 p-2 flex items-center gap-2"
                                        onClick={() => refetch()}
                                    >
                                        {
                                            isLoading ? <Loader2Icon width={15} height={15} className="shrink-0 animate-spin" /> : <>Try again<Repeat width={15} height={15} className="shrink-0" /></>
                                        }
                                    </button>
                                </div>
                                : <div className="w-full p-4 text-center">{translate_empties('notifications')}</div>
                    }

                </div>
                <div className="flex items-center justify-center p-2 border-t border-slate-200">
                    <Link onClick={() => setIsOpen(false)} className="hover:bg-opacity-70 transition-colors rounded-sm text-sm p-2 bg-[#405189] text-white" href={'/notifications'}>{translate('buttons.view_all')}</Link>
                </div>
            </div>
        </div>
    );
};

export default Notifications;
